<template>
  <div class="custom-stepper">
    <div class="left-buttons">
      <DxButton class="left" text="Cancel" @click="$emit('hide-modal')" />
    </div>
    <div class="steps-container">
      <stepper
        :alt-labels="true"
        @change="changeStep"
        :value="currentStepIdx + 1"
      >
        <step-header>
          <Fragment v-for="(step, idx) in steps" :key="`Step-${idx}`">
            <step :step="idx + 1" :editable="completedStepIdx >= idx">
              {{ steps[idx].StepName }}
              <!-- {{ steps[idx].split(':')[1] }} -->
            </step>
            <step-divider v-if="idx < steps.length - 1"></step-divider>
          </Fragment>
        </step-header>
      </stepper>
    </div>

    <div class="right-buttons">
      <DxButton
        v-if="steps[currentStepIdx].ShowBackButton"
        text="Back"
        @click="$emit('show-last-step')"
      />
      <span
        id="diabledToolTip"
        @mouseenter="showToolTip"
        @mouseleave="hideToolTip"
      >
        <DxButton
          v-if="steps[currentStepIdx].ShowNextButton"
          :text="steps[currentStepIdx].NextButtonText"
          type="default"
          :disabled="requiredFieldNeeded"
          @click="handleContinue"
        />
      </span>
      <DxTooltip
        v-if="requiredFieldNeeded ? showDisabledToolTip : false"
        :visible="requiredFieldNeeded ? showDisabledToolTip : false"
        :close-on-outside-click="false"
        target="#diabledToolTip"
        :position="'top'"
      >
        <div class="tooltipBody">
          <span
            v-html="diabledToolTip ? diabledToolTip : continueBtnHoverText"
          ></span>
        </div>
      </DxTooltip>
    </div>
  </div>
</template>

<script>
import { DxTooltip } from "devextreme-vue/tooltip";
import DxButton from "devextreme-vue/button";
import {
  VStepper as Stepper,
  VStepperHeader as StepHeader,
  VDivider as StepDivider,
  VStepperStep as Step,
} from "vuetify/lib";
const Fragment = {
  functional: true,
  render: (h, ctx) => ctx.children,
};

export default {
  name: "CustomStepper",
  props: {
    steps: Array,
    currentStepIdx: Number,
    currentStepName: String,
    completedStepIdx: Number,
    requiredFieldNeeded: Boolean,
    continueBtnHoverText: String,
    diabledToolTip: String,
  },
  components: {
    Stepper,
    StepHeader,
    StepDivider,
    Step,
    Fragment,
    DxButton,
    DxTooltip,
  },
  data() {
    return {
      showDisabledToolTip: false,
    };
  },
  methods: {
    changeStep(newVal) {
      this.$emit("update:currentStepIdx", newVal - 1);
    },
    handleContinue() {
      this.$emit("show-next-step");
    },
    showToolTip() {
      this.showDisabledToolTip = true;
    },
    hideToolTip() {
      this.showDisabledToolTip = false;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.custom-stepper {
  padding-top: 15px;
  display: grid;
  grid-template-columns: 10% 70% 20%;
  grid-template-areas: "left-buttons stepper right-buttons";

  .dx-button {
    margin: 2px;
    font-size: 12px;
    // padding: 6px 12px;
  }

  .dx-state-disabled {
    pointer-events: initial;
  }

  .dx-button-mode-contained.dx-button-default {
    background-color: #006ca5;
  }
}

.left-buttons {
  grid-area: left-buttons;
}

.right-buttons {
  grid-area: right-buttons;
  .dx-button {
    float: left;
  }
}

.left-buttons,
.right-buttons {
  padding-top: 0px;
}

.steps-container {
  grid-area: stepper;

  .v-stepper {
    box-shadow: none;
  }

  .v-stepper__header {
    .v-divider {
      margin-top: 15px;
    }
  }

  .v-stepper__step::v-deep {
    padding: 3px;

    .v-stepper__label {
      font-size: 11px;
    }

    .v-stepper__step__step {
      margin-bottom: 4px;
    }
  }

  .v-stepper__step--active::v-deep {
    .v-stepper__step__step {
      background-color: #006ca5;
    }
  }

  .v-stepper__step--editable.v-stepper__step:not(.v-stepper__step--active)::v-deep {
    .v-stepper__step__step {
      border: 1px solid rgba(0, 0, 0, 0.38);
      color: rgba(0, 0, 0, 0.38);
      background: hsla(255, 255, 255, 0) !important;
    }
  }

  .v-stepper__step--editable:hover::v-deep {
    background-color: rgba(255, 255, 255, 0);

    .v-stepper__step__step {
      transform: scaleX(1.2) scaleY(1.2);
      font-weight: bold;
    }

    .v-stepper__label {
      font-weight: bold;
    }
  }
}
.tooltipBody {
  text-align: left;
  color: black;
  background-color: #e0d9d9;
  padding: 15px;
  margin: -10px;
  border-radius: 5px;
}
.tooltipBody:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -10px;
  width: 0;
  height: 0;
  border-top: solid 10px #e0d9d9;
  border-left: solid 10px transparent;
  border-right: solid 10px transparent;
}
.left {
  float: left;
}
</style>
